import {createSlice} from '@reduxjs/toolkit';
import {createPrice, deletePris, getAllPrices, updatePrice,} from '../services/prices';

const priceSlice = createSlice({
  name: 'price',
  initialState: [],
  reducers: {
    setPrices(state, action) {
      return action.payload;
    },
    clearPrices() {
      return [];
    },
    addPrice(state, action) {
      state.push(action.payload);
    },
    
    updatePriceInList(state, action) {
      if (!action.payload.id) {
        console.error("Price update action must have an id");
        return state;
      }
      return state.map(price =>
        price.id === action.payload.id ? action.payload : price
      );
    },
    
    deletePriceFromList(state, action) {
      return state.filter(price => price.id !== action.payload);
    },
  },
});

// Async thunks

export const fetchPrices = () => async dispatch => {
  const prices = await getAllPrices();
  dispatch(setPrices(prices));
};

export const savePriceList = () => {
  return async dispatch => {
    const newPriceList = await getAllPrices();
    dispatch(setPrices(newPriceList));
  };
};

export const createNewPrice = priceData => async dispatch => {
  const newPrice = await createPrice(priceData);
  dispatch(addPrice(newPrice));
};

export const editPrice = (id, updatedData) => async dispatch => {
  const updatedPrice = await updatePrice(id, updatedData);
  dispatch(updatePriceInList(updatedPrice));
};

export const removePrice = id => async dispatch => {
  await deletePris(id);
  dispatch(deletePriceFromList(id));
};


export const refreshPris = () => {
  return async (dispatch) => {
    const prices = await getAllPrices();
    dispatch(setPrices(prices));
  };
};

// Export actions and reducer
export const {
  setPrices,
  addPrice,
  updatePriceInList,
  deletePriceFromList,
} = priceSlice.actions;

export default priceSlice.reducer;
